import React from "react";

const getInitials = (name) => {
  return name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
};

const ImageOrInitials = ({ src, alt, size = "small" }) => {
  const sizeClasses = {
    small: "w-6 h-6",
    medium: "w-8 h-8",
    large: "w-10 h-10",
  };

  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        className={`${sizeClasses[size]} rounded-full`}
      />
    );
  }

  return (
    <div
      className={`${sizeClasses[size]} rounded-full bg-gray-100 flex items-center justify-center text-secondary font-medium`}
    >
      {getInitials(alt)}
    </div>
  );
};

const AgencyRecentActivityCard = ({ agencyActivities, agencyLoading }) => {
  return (
    <div className="bg-[#121843] text-white rounded-lg w-full lg:flex-[27]">
      <h3 className="text-base font-medium mb-3 bg-[#1B204A] rounded-lg px-6 py-3 text-white">
        Recent Activity
      </h3>
      <div className="space-y-4 h-[calc(100%-3rem)] overflow-y-auto px-6">
        {agencyLoading ? (
          <div className="flex flex-col pb-4 pt-1 animate-pulse">
            <div className="h-3 bg-gray-700 rounded w-24 mb-2"></div>
            <div className="h-5 bg-gray-700 rounded w-48 mb-3"></div>
            <div className="h-4 bg-gray-700 rounded w-32 mb-2"></div>
            <div className="h-4 bg-gray-700 rounded w-40 mb-4"></div>
            <div className="h-8 bg-gray-700 rounded w-32"></div>
          </div>
        ) : agencyActivities && agencyActivities.length > 0 ? (
          <div className="flex flex-col pb-4 pt-1">
            <div className="text-[10px] font-medium text-[#FFFFFF]/50">
              {new Date(agencyActivities[0]?.dateSent).toLocaleString()}
            </div>
            <h4 className="font-medium mt-1 text-white text-base">
              {agencyActivities[0]?.status === "accepted"
                ? `Your pitch for "${agencyActivities[0]?.position}" was accepted`
                : agencyActivities[0]?.status === "rejected"
                ? `Your pitch for "${agencyActivities[0]?.position}" was rejected`
                : `New pitch for "${agencyActivities[0]?.position}" was sent`}
            </h4>
            <div className="flex items-center gap-2 mt-3 text-xs font-medium">
              <ImageOrInitials
                src={agencyActivities[0]?.club?.logo}
                alt={agencyActivities[0]?.club?.name || "Club"}
                size="small"
              />
              <span>By {agencyActivities[0]?.club?.name || "Club"}</span>
            </div>
            <p className="text-xs text-white font-medium mt-3">
              {agencyActivities[0]?.status === "accepted"
                ? "Kindly connect with club and discuss the details of the transfer and make sure everything is right."
                : agencyActivities[0]?.status === "rejected"
                ? "The club has rejected this pitch. You may want to follow up or try with another player."
                : "Your agent has sent a new pitch. You can track the status in the pitches section."}
            </p>
            <button className="mt-6 text-sm bg-[#2283FF] p-2 text-[#F5F5F5] font-medium rounded-lg w-full md:w-[90%]">
              Switch to Agent profile {">"} Applied Pitches
            </button>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-full py-10">
            <p className="text-white text-sm">No recent activities</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AgencyRecentActivityCard;
